import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { resetDisputeIdices } from "../disputeUXSlice";
import { PageIndex } from "../../../models";
import { setDisputeIndexThunk } from "../thunks/loadDisputes";

export const useDisputeIndex = () => {
  const pageIndex = useSelector<StoreType, PageIndex>(
    (s) => s.ux.clearing.disputes.index
  );

  const dispatch = useDispatch();
  const dispatchSetIndex = React.useCallback(
    (index: PageIndex) => dispatch(setDisputeIndexThunk(index)),
    [dispatch]
  );
  const dispatchResetIndex = React.useCallback(
    () => dispatch(resetDisputeIdices()),
    [dispatch]
  );

  return [pageIndex, dispatchSetIndex, dispatchResetIndex] as [
    typeof pageIndex,
    typeof dispatchSetIndex,
    typeof dispatchResetIndex
  ];
};
